import { EDSComponent } from "@emartech/eds-utils-component";

export interface OrderItemInterface {
  id: string;
  order: number;
  size: number;
  content?: Element;
}

export class OrderItemComponent extends EDSComponent {
  static componentName = "order-item";

  private _id: string;
  private _order: number;
  private _size: number;

  static get observedAttributes() {
    return ["id", "order", "size"];
  }

  get id() {
    return this._id;
  }

  set id(value) {
    this._id = value;
    this._dispatchEvent("update-item");
  }

  get order() {
    return this._order;
  }

  set order(value: any) {
    this._order = parseInt(value, 10);
    this._dispatchEvent("update-item");
  }

  get size() {
    return this._size;
  }

  set size(value: any) {
    this._size = parseInt(value, 10);
    this._dispatchEvent("update-item");
  }

  connectedCallback() {
    this._dispatchEvent("order-item");

    const observer = new MutationObserver((mutations) => this._handleMutations(mutations));
    observer.observe(this, {
      attributes: true,
      childList: true,
      subtree: false,
    });
  }

  disconnectedCallback() {
    const event = new CustomEvent("remove-item", {
      detail: this._getDetails(),
    });
    this.dispatchEvent(event);
  }

  createRenderRoot() {
    return this;
  }

  _handleMutations(mutations: MutationRecord[]) {
    for (const mutation of mutations) {
      if (mutation.type === "childList" && mutation.addedNodes.length === 0) {
        return;
      }

      this._dispatchEvent("update-item");
    }
  }

  _dispatchEvent(eventName: string) {
    const detail = this._getDetails();

    if (this.children[0]) {
      detail.content = this.children[0];
    }

    const event = new CustomEvent(eventName, {
      detail,
      bubbles: true,
    });

    this.dispatchEvent(event);
  }

  _getDetails(): OrderItemInterface {
    return {
      id: this._id,
      order: this._order,
      size: this._size,
    };
  }
}
